import React from 'react'
import classnames from 'classnames'

import { ModalContent } from 'src/shared/components/common/modal'
import { t } from 'src/translations'
import { Button } from 'shared/components/common/button'

type LogoutConfirmationProps = {
  onConfirm: () => void
  onCancel: () => void
  isMobile: boolean
}

export const LogoutConfirmation = ({
  onConfirm,
  onCancel,
  isMobile
}: LogoutConfirmationProps) => {
  return (
    <ModalContent
      contentClassName={classnames(
        'modalContentV2 logoutConfirmationModalContent',
        isMobile && 'bottomDrawerMobile mobile'
      )}
    >
      <div className='header' data-testid='LogoutConfirmation'>
        <div className='text'>
          <div className='headerText'>{t('logout.log-out')}</div>
          <div className='message'>{t('logout.are-you-sure')}</div>
        </div>
      </div>
      <div className={classnames('body', isMobile && 'mobile')}>
        <Button
          className='cancelButton'
          onClick={onCancel}
          testId='logout-confirm-cancel'
        >
          {t('logout.cancel')}
        </Button>
        <Button
          className='confirmButton'
          onClick={onConfirm}
          testId='logout-confirm-logout'
        >
          {t('logout.log-out')}
        </Button>
      </div>
    </ModalContent>
  )
}
